import { useEffect } from 'react'
import { useAppSelector } from '@/redux/hooks'
import {
  registerEcommerceScopePosthog,
  toEcommerceScope
} from '@/infrastructure/posthog'

// Must run before usePageVisit so $pageview already carries the scope.
export function useEcommerceScope() {
  const selectedEcommerce = useAppSelector(
    (s) => s.generalData.selectedEcommerce
  )
  const selectedGroup = useAppSelector((s) => s.generalData.selectedGroup)
  const ecommerceCount = useAppSelector(
    (s) => s.userApi.getMe.response.user?.e_commerces_ids?.length ?? 0
  )

  useEffect(() => {
    registerEcommerceScopePosthog(
      toEcommerceScope(selectedEcommerce, selectedGroup),
      ecommerceCount
    )
  }, [selectedEcommerce, selectedGroup, ecommerceCount])
}
